import { useState, useEffect } from 'react'
import SearchAndSelectField, { SearchResultItem } from '../SearchAndSelectField'
import usePayoutCreditFacilitySelectorActions from '../../hooks/usePayoutCreditFacilitySelectorActions'

interface Props {
    onPayoutCreditFacilitySelected: (employer: SearchResultItem | null) => void
    value: string
 }

const PayoutCreditFacilitySelector = ({ onPayoutCreditFacilitySelected = () => '', value}: Props) => {
    const [resultItems, setResultItems] = useState<SearchResultItem[]>()
    const { search, facilities } = usePayoutCreditFacilitySelectorActions()

    useEffect(() => {
        if (facilities) {
            const items = facilities.map((item) => {
                return {name: item.name ?? '', value: item.id}
            })
            setResultItems(items)
        } else{
            setResultItems([])   
        }              
    }, [facilities])

    const handleSearchTermChange = (searchTerm: string) => {
        search(searchTerm, 10)
    }
    
    const handleFacilitySelected = (selectedItem: SearchResultItem | null) => {
        onPayoutCreditFacilitySelected && onPayoutCreditFacilitySelected(selectedItem ?? null)
    }

    return (
        <>
            <SearchAndSelectField
                placeholder='Search payout credit facility'
                id='payoutCreditFacilitySearch'
                onSearchTermChange={handleSearchTermChange}
                onSelect={handleFacilitySelected}
                value={value}
                searchResult={resultItems ?? []}
            /> 
        </>
    )
}

export default PayoutCreditFacilitySelector
